import React, { Component } from "react";
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"

class Footer extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { montoTotales, resumen, data, cuotasPendientesTotales } = this.props;

        let cuoPen = cuotasPendientesTotales ? cuotasPendientesTotales : [];

        let cuotasPendientesTotalesPesos = ((cuoPen.length) ? (cuotasPendientesTotales[0].DNVPESO ? cuotasPendientesTotales[0].DNVPESO : 0) : 0);
        let cuotasPendientesTotalesUsd = ((cuoPen.length) ? (cuotasPendientesTotales[0].DNVUSD ? cuotasPendientesTotales[0].DNVUSD : 0) : 0);

        let totalConsumoTarjetaPesos = 0;
        let totalConsumoTarjetaUsd = 0;
        let saldoAntImpPesos = 0;
        let saldoAntImpUsd = 0;
        let saldoTotalAntImpPesos = 0;
        let saldoTotalAntImpUsd = 0;
        let totalPerFecPesos = 0;
        let totalPerFecUsd = 0;

        montoTotales.map((item, index) => {
            if (item.MonedaOrigenId == 1)
                totalConsumoTarjetaPesos += item.Importe;
            else
                totalConsumoTarjetaUsd += item.Importe;
        });

        resumen.map((item, index) => {
            if (item.CobranzaMonedaId == 1)
                saldoAntImpPesos += item.Importe;
            else
                saldoAntImpUsd += item.Importe;
        })

        saldoTotalAntImpPesos = data.SaldoCierrePesos - saldoAntImpPesos;
        saldoTotalAntImpUsd = data.SaldoCierreUss - saldoAntImpUsd;

        totalPerFecPesos = totalConsumoTarjetaPesos + saldoTotalAntImpPesos;
        totalPerFecUsd = totalConsumoTarjetaUsd + saldoTotalAntImpUsd;

        let deudaTotalPesos = ((cuotasPendientesTotalesPesos != 0) ? (totalPerFecPesos + cuotasPendientesTotalesPesos).toFixed(2) : totalPerFecPesos.toFixed(2));
        let deudaTotalUsd = ((cuotasPendientesTotalesUsd != 0) ? (totalPerFecUsd + cuotasPendientesTotalesUsd).toFixed(2) : totalPerFecUsd.toFixed(2));

        return (
            <div className="box header colorSR">
                {/*Total Consumos Tarjetas*/}
                <div className="row no-margin">
                    <div className="col-xs-3"></div>
                    <div className="col-xs-5 text-left">
                        <label className="label-secondary">Total Consumos Tarjetas</label>
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={totalConsumoTarjetaPesos.toFixed(2)} moneda="" class="label-secondary" />
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={totalConsumoTarjetaUsd.toFixed(2)} moneda="" class="label-secondary" />
                    </div>
                </div>
                {/*Saldo Anterior Impago*/}
                <div className="row no-margin">
                    <div className="col-xs-3"></div>
                    <div className="col-xs-5 text-left">
                        <label className="label-primary">Saldo Anterior Impago</label>
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={saldoTotalAntImpPesos.toFixed(2)} moneda="" class="label-secondary" />
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={saldoTotalAntImpUsd.toFixed(2)} moneda="" class="label-secondary" />
                    </div>
                    <div className="col-xs-12">
                        <hr className="hr-resumenes" />
                    </div>
                </div>
                {/*Total del Período a la Fecha*/}
                <div className="row no-margin">
                    <div className="col-xs-3"></div>
                    <div className="col-xs-5 text-left">
                        <label className="label-secondary">Total del Período</label>
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={parseFloat(totalPerFecPesos).toFixed(2)} moneda="" class="label-secondary" />
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={parseFloat(totalPerFecUsd).toFixed(2)} moneda="" class="label-secondary" />
                    </div>
                </div>
                {/*Total Cuotas Pendientes*/}
                <div className="row no-margin">
                    <div className="col-xs-3"></div>
                    <div className="col-xs-5 text-left">
                        <label className="label-primary">Total Cuotas Pendientes</label>
                        <a className="btn-link-sm btn-link-labeled-primary ti-sm hand" onClick={() =>
                            this.props.getCuotasPendientes(this.props.cuentaTarjetaId, data.FechaCierreAnterior, data.FechaCierre, data.FechaHoy)}>
                            Ver Detalles
                        </a>
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={cuotasPendientesTotalesPesos.toFixed(2)} moneda="" class="label-secondary" />
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={cuotasPendientesTotalesUsd.toFixed(2)} moneda="" class="label-secondary" />
                    </div>
                    <div className="col-xs-12">
                        <hr className="hr-resumenes" />
                    </div>
                </div>
                {/*Deuda total*/}
                <div className="row no-margin">
                    <div className="col-xs-3"></div>
                    <div className="col-xs-5 text-left">
                        <label className="label-primary">Deuda Total</label>
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={deudaTotalPesos} moneda="" class="label-secondary" />
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={deudaTotalUsd} moneda="" class="label-secondary" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;